import React, {Component} from 'react';
import {connect} from 'react-redux';
import Tooltip from 'components/atoms/tooltip';

class TeamLogo extends Component {
    render() {
        const {teamsInfo, teamName} = this.props;
        const team = teamsInfo.getById(teamName);
        if (!team) return null;
        let className = team.logo ? 'team-logo' : 'team-name';
        let logoBlock = <img src={team.logo} alt={teamName} />;
        let teamBlock = team.logo ? (
            <Tooltip subject={teamName} tabIndex={false}>
                {logoBlock}
            </Tooltip>
        ) : (
            teamName
        );

        return <span className={className}>{teamBlock}</span>;
    }
}

function mapStatesToProps(state) {
    const {teamsInfo} = state;
    return {
        teamsInfo,
    };
}

export default connect(mapStatesToProps)(TeamLogo);
